const HideFetched = ({ name, fetchedParams, children }) => {
  if(name && fetchedParams) {
    // If we were passed an array of names
    if(Array.isArray(name)) {
      // If any of them are not in fetchedParams, show the element
      if(name.some((n) => !fetchedParams[n])) {
        return children
      }
      // If all of them are in fetchedParams, hide the element
      else {
        return null
      }
    }
    else {
      // If the named element is in fetchedParams, hide
      return fetchedParams[name] ? null : children
    }
  }
  else {
    // fetchedParams is empty or name parameter is not in fetchedParams
    return children
  }
}

export default HideFetched



// WEBPACK FOOTER //
// ./src/components/SignupWidget/HideFetched.js